import { Injectable, Inject } from '@angular/core';
import { HttpService } from './http.service';
import { ActionService } from './action.service';
import { MessageService } from './message.service';
import { RequestQueueService } from './request-queue.service';
import { UtilService } from './util.service';
import { SpinnerService } from './spinner.service';
import { PlusNotificationService } from './plus-notification.service';
import { ConfirmationService } from './confirmation.service';
@Injectable()
export class ServiceProvider {

  public httpService: HttpService;
  public actionService: ActionService;
  public listenersComponents: any[] = [];
  public utilService: UtilService;
  public messageService: MessageService;
  public spinnerService: SpinnerService;
  public plusNotService: PlusNotificationService;
  public confirmService: ConfirmationService;
  public requestQueueService: RequestQueueService;
  public isLoading: boolean;

  constructor() {
    }
  }
